import React, { Component } from "react";
import Modal from "react-awesome-modal";
import { Card, CardTitle, CardBody, CardFooter, Button } from "reactstrap";
import "../../../Shared/Forms/form.css";
class AppManual extends Component {
  constructor(props) {
    super(props);
    this.state = {
      visible: false,
      instructorPostVisible: false,
      adminVisible: false,
      category: false,
      interest: false,
      activity: false,
      event: false,
      instructor: false,
      disableOverLay:false
    };
  }
  closeHandManual = () => {
    this.props.closeHandManual();
  };

  closeCreateInstructorPostManual = () => {
    this.setState({ instructorPostVisible: !this.state.instructorPostVisible,disableOverLay:!this.state.disableOverLay});
  };
  closeOpenAdminManual = () => {
    this.setState({ adminVisible: !this.state.adminVisible ,disableOverLay:false});

  };
  closeCreateAdminManual = e => {
    let id = e.target.id;

    switch (id) {
      case "1":
        this.setState({
          category: true,
          interest: false,
          activity: false,
          event: false,
          instructor: false,
          adminVisible: true,
          disableOverLay:true,
        });
        break;
      case "2":
        this.setState({
          category: false,
          interest: true,
          activity: false,
          event: false,
          instructor: false,
          adminVisible: true,
          disableOverLay:true,
        });
        break;

      case "3":
        this.setState({
          category: false,
          interest: false,
          activity: true,
          event: false,
          instructor: false,
          adminVisible: true,
          disableOverLay:true,
        });
        break;

      case "4":
        this.setState({
          category: false,
          interest: false,
          activity: false,
          event: true,
          instructor: false,
          adminVisible: true,
          disableOverLay:true,
        });
        break;

      case "5":
        this.setState({
          category: false,
          interest: false,
          activity: false,
          event: false,
          instructor: true,
          adminVisible: true,
          disableOverLay:true,
        });
        break;

      default:
          this.setState({
            category: false,
            interest: false,
            activity: false,
            event: false,
            instructor: false,
            adminVisible: false,
            disableOverLay:false,
          });
        break;
    }
  };
  render() {
    const { visible, role } = this.props;

    const {
      instructorPostVisible,
      adminVisible,
      category,
      interest,
      activity,
      event,
      instructor,
      disableOverLay
    } = this.state;
    if (role === "ROLE_VLA_INSTRUCTOR") {
      return (
        <section>
       {
         !disableOverLay ? (
          <Modal
            visible={visible}
            width="500"
            height="500"
            effect="fadeInUp"
            onClickAway={this.closeHandManual}
          >
            <Card style={{ height: "32rem" }}>
              <CardBody>
                <CardTitle>
                  <h2
                    style={{ fontSize: "25px", textAlign: "center" }}
                    className="mb-6"
                  >
                    Verve Life Manual
                  </h2>{" "}
                </CardTitle>
                <p className="ml-1 mr-1 mb-6" style={{ marginTop: "2rem" }}>
                  Click on any of the topics for more details.
                </p>
                <div className="mb-6">
                  <p
                    onClick={this.closeCreateInstructorPostManual}
                    className="ml-1 mr-1 mb-3"
                    style={{ cursor: "pointer", color: "blue" }}
                  >
                    How to create a post.
                  </p>
                </div>
              </CardBody>
              <CardFooter>
                <Button
                  color="primary mb-2"
                  size="sm"
                  onClick={this.closeHandManual}
                  type="button"
                  className="align-items-center"
                  style={{ marginLeft: "12rem" }}
                >
                  Close
                </Button>
              </CardFooter>
            </Card>
          </Modal>
         ):null
       }

          <Modal
            visible={instructorPostVisible}
            width="500"
            height="500"
            effect="fadeInRight"
            onClickAway={this.closeCreateInstructorPostManual}
          >
            <Card style={{ height: "32rem" }}>
              <CardBody style={{ textAlign: "center" }}>
                <h6 className="ml-1 mr-1 mb-6" style={{ marginTop: "2rem" }}>
                Follow these steps in creating a post.
                </h6>
                <div
                  className="mb-6"
                  style={{
                    marginTop: "2rem",
                    textAlign: "left",
                    paddingLeft: "1rem",
                  }}
                >
                  <p className="ml-1 mr-1 mb-3">
                    1) Click the upload content icon on the side-bar.
                  </p>
                  <p className="ml-1 mr-1 mb-3">
                    2) Select interest for the post (from instructor's interest
                    drop down).
                  </p>
                  <p className="ml-1 mr-1 mb-3">3)Enter your post title.</p>
                  <p className="ml-1 mr-1 mb-3">
                    4)Choose your post's header image (Note this is optional).
                  </p>
                  <p className="ml-1 mr-1 mb-3">
                    5)Enter the main content of your post.
                  </p>
                  <p className="ml-1 mr-1 mb-3">
                    6)You can click save draft to save your post or click the publish button to send your post for approval.
                  </p>
                </div>
              </CardBody>
              <CardFooter>
                <Button
                  color="primary mb-2"
                  size="sm"
                  onClick={this.closeCreateInstructorPostManual}
                  type="button"
                  className="align-items-center"
                  style={{ marginLeft: "12rem" }}
                >
                  Back
                </Button>
              </CardFooter>
            </Card>
          </Modal>
        </section>
      );
    } else if (role === "ROLE_VLA_ADMIN") {
      return (
        <section>{
          !disableOverLay ? (
            <Modal
            visible={visible}
            width="500"
            height="500"
            effect="fadeInUp"
            onClickAway={this.closeHandManual}
          >
            <Card style={{ height: "32rem" }}>
              <CardBody>
                <CardTitle>
                  <h2
                    style={{ fontSize: "25px", textAlign: "center" }}
                    className="mb-6"
                  >
                    Verve Life Manual
                  </h2>{" "}
                </CardTitle>
                <p className="ml-1 mr-1 mb-6" style={{ marginTop: "2rem" }}>
                  Click on any of the topics for more details.
                </p>
                <div className="mb-6">
                  <p
                    onClick={this.closeCreateAdminManual}
                    className="ml-1 mr-1 mb-3"
                    style={{ cursor: "pointer", color: "blue" }}
                    id={1}
                  >
                    How to create a category.
                  </p>
                  <p
                    onClick={this.closeCreateAdminManual}
                    className="ml-1 mr-1 mb-3"
                    style={{ cursor: "pointer", color: "blue" }}
                    id={2}
                  >
                    How to create an interest.
                  </p>
                  <p
                    onClick={this.closeCreateAdminManual}
                    className="ml-1 mr-1 mb-3"
                    style={{ cursor: "pointer", color: "blue" }}
                    id={3}
                  >
                    How to create an activity.
                  </p>
                  <p
                    onClick={this.closeCreateAdminManual}
                    className="ml-1 mr-1 mb-3"
                    style={{ cursor: "pointer", color: "blue" }}
                    id={4}
                  >
                    How to create an event.
                  </p>
                  <p
                    onClick={this.closeCreateAdminManual}
                    className="ml-1 mr-1 mb-3"
                    style={{ cursor: "pointer", color: "blue" }}
                    id={5}
                  >
                    How to create an instructor.
                  </p>
                </div>
              </CardBody>
              <CardFooter>
                  <Button
                    color="primary mb-2"
                    size="sm"
                    onClick={this.closeHandManual}
                    type="button"
                    className="align-items-center"
                    style={{ marginLeft: "12rem" }}
                  >
                    Close
                  </Button>
                </CardFooter>
            </Card>
          </Modal>
          ):null
        }
          

          <Modal
            visible={adminVisible}
            width="500"
            height="500"
            effect="fadeInRight"
            onClickAway={this.closeCreateInstructorPostManual}
          
          >
            {category && (
              <Card style={{ height: "32rem" }}>
                <CardBody style={{ textAlign: "center" }}>
                  <h6 className="ml-1 mr-1 mb-6" style={{ marginTop: "2rem" }}>
                  Follow these steps to create a category.
                  </h6>
                  <div
                    className="mb-6"
                    style={{
                      marginTop: "2rem",
                      textAlign: "left",
                      paddingLeft: "1rem",
                    }}
                  >
                    <p className="ml-1 mr-1 mb-3">
                      1) Click the settings drop-down on the side-bar and click
                      on categories.
                    </p>
                    <p className="ml-1 mr-1 mb-3">
                      2) Enter your category title.
                    </p>
                    <p className="ml-1 mr-1 mb-3">
                      3) Enter your category description.
                    </p>
                    <p className="ml-1 mr-1 mb-3">
                      4) Click the create button.
                    </p>
                  </div>
                </CardBody>
                <CardFooter>
                  <Button
                    color="primary mb-2"
                    size="sm"
                    onClick={this.closeOpenAdminManual}
                    type="button"
                    className="align-items-center"
                    style={{ marginLeft: "12rem" }}
                  >
                    Back
                  </Button>
                </CardFooter>
              </Card>
            )}
            {interest && (
              <Card style={{ height: "32rem" }}>
                <CardBody style={{ textAlign: "center" }}>
                  <h6 className="ml-1 mr-1 mb-6" style={{ marginTop: "2rem" }}>
                  Follow these steps to create an interest.
                  </h6>
                  <div
                    className="mb-6"
                    style={{
                      marginTop: "2rem",
                      textAlign: "left",
                      paddingLeft: "1rem",
                    }}
                  >
                    <p className="ml-1 mr-1 mb-3">
                      1) Click the settings drop-down on the side-bar and click
                      on interests.
                    </p>
                    <p className="ml-1 mr-1 mb-3">
                      2) Enter your interest title.
                    </p>
                    <p className="ml-1 mr-1 mb-3">
                      3) Enter your interest description.
                    </p>
                    <p className="ml-1 mr-1 mb-3">
                      4) Type a minimum of three characters to assign interest
                      to a category.
                    </p>
                    <p className="ml-1 mr-1 mb-3">
                      5) Click the create button.
                    </p>
                  </div>
                </CardBody>
                <CardFooter>
                  <Button
                    color="primary mb-2"
                    size="sm"
                    onClick={this.closeOpenAdminManual}
                    type="button"
                    className="align-items-center"
                    style={{ marginLeft: "12rem" }}
                  >
                     Back
                  </Button>
                </CardFooter>
              </Card>
            )}
            {activity && (
              <Card style={{ height: "32rem" }}>
                <CardBody style={{ textAlign: "center" }}>
                  <h6 className="ml-1 mr-1 mb-6" style={{ marginTop: "2rem" }}>
                  Follow these steps to create an activity.
                  </h6>
                  <div
                    className="mb-6"
                    style={{
                      marginTop: "2rem",
                      textAlign: "left",
                      paddingLeft: "1rem",
                    }}
                  >
                    <p className="ml-1 mr-1 mb-3">
                      1) Click the settings drop-down on the side-bar and click
                      on activities.
                    </p>
                    <p className="ml-1 mr-1 mb-3">2) Enter activity title.</p>
                    <p className="ml-1 mr-1 mb-3">
                      3) Enter activity MET value.
                    </p>
                    <p className="ml-1 mr-1 mb-3">
                      4) Select activity metric (more than one activity metric
                      can be selected).
                    </p>
                    <p className="ml-1 mr-1 mb-3">
                      5) Click the create button.
                    </p>
                  </div>
                </CardBody>
                <CardFooter>
                  <Button
                    color="primary mb-2"
                    size="sm"
                    onClick={this.closeOpenAdminManual}
                    type="button"
                    className="align-items-center"
                    style={{ marginLeft: "12rem" }}
                  >
                     Back
                  </Button>
                </CardFooter>
              </Card>
            )}
            {event && (
              <Card style={{ height: "32rem" }}>
                <CardBody style={{ textAlign: "center" }}>
                  <h6 className="ml-1 mr-1 mb-6" style={{ marginTop: "2rem" }}>
                  Follow these steps to create an event.
                  </h6>
                  <div
                    className="mb-6"
                    style={{
                      marginTop: "2rem",
                      textAlign: "left",
                      paddingLeft: "1rem",
                    }}
                  >
                    <p className="ml-1 mr-1 mb-3">
                      1) Click the settings drop-down on the side-bar and click
                      on events.
                    </p>
                    <p className="ml-1 mr-1 mb-3">2) Enter event title.</p>
                    <p className="ml-1 mr-1 mb-3">3) Enter event location.</p>
                    <p className="ml-1 mr-1 mb-3">4) Enter event description.</p>
                    <p className="ml-1 mr-1 mb-3">
                      5) Select start date and end date of the event.
                    </p>
                    <p className="ml-1 mr-1 mb-3">
                      6) Click the create button.
                    </p>
                  </div>
                </CardBody>
                <CardFooter>
                  <Button
                    color="primary mb-2"
                    size="sm"
                    onClick={this.closeOpenAdminManual}
                    type="button"
                    className="align-items-center"
                    style={{ marginLeft: "12rem" }}
                  >
                    Back
                  </Button>
                </CardFooter>
              </Card>
            )}
            {instructor && (
              <Card style={{ height: "32rem" }}>
                <CardBody style={{ textAlign: "center" }}>
                  <h6 className="ml-1 mr-1 mb-6" style={{ marginTop: "2rem" }}>
                  Follow these steps to create an instructor.
                  </h6>
                  <div
                    className="mb-6"
                    style={{
                      marginTop: "2rem",
                      textAlign: "left",
                      paddingLeft: "1rem",
                    }}
                  >
                    <p className="ml-1 mr-1 mb-3">
                      1) Click the settings drop-down on the side-bar and click
                      on instructors.
                    </p>
                    <p className="ml-1 mr-1 mb-3">
                      2) Enter instructor's first name.
                    </p>
                    <p className="ml-1 mr-1 mb-3">
                      3) Enter instructor's last name.
                    </p>
                    <p className="ml-1 mr-1 mb-3">
                      4) Enter instructor's email address.
                    </p>
                    <p className="ml-1 mr-1 mb-3">
                      5) Enter instructor's mobile number.
                    </p>
                    <p className="ml-1 mr-1 mb-3">
                      6) Enter instructor's business name.
                    </p>
                    <p className="ml-1 mr-1 mb-3">
                      7) Assign interest to the instructor.
                    </p>
                    <p className="ml-1 mr-1 mb-3">
                      8) Click the create button.
                    </p>
                  </div>
                </CardBody>
                <CardFooter >
                  <Button
                    color="primary mb-2"
                    size="sm"
                    onClick={this.closeOpenAdminManual}
                    type="button"
                    className="align-items-center"
                    style={{ marginLeft: "12rem" }}
                  >
                     Back
                  </Button>
                </CardFooter>
              </Card>
            )}
          </Modal>
        </section>
      );
    } else {
      return <span />;
    }
  }
}

export default AppManual;
